import { Component } from '@angular/core';
import {
  FieldType,
  FormlyExtension,
  FormlyFieldConfig
} from '@ngx-formly/core';
import { CertificateBody2026 } from '../../form-parts-definition_2026';

@Component({
  selector: 'tpa-idcard-2026',
  templateUrl: './idcard-2026.component.html',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'tpa-wrapper__control' },
})
export class IdCard2026Component extends FieldType implements FormlyExtension {
  defaultOptions = {
    className: 'p-col-12',
    props: {
      translate: true,
      open: false,
    },
  };

  onPopulate(field: FormlyFieldConfig) {
    if (field.fieldGroup) {
      return;
    }
    field.fieldGroup = CertificateBody2026();
  }
}
